<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="图片：">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
      <el-form-item label="拍摄者：">
        <el-select v-model="operateAdminId" placeholder="请选择" style="width: 100%;flex: 1" :disabled="positionType == 4">
          <el-option v-for="e in adminList" :key="e.id" :label="e.name" :value="e.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import {addPreBookPetImg, getOperateAdminsList} from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";
import * as imageConversion from 'image-conversion'

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      preShopId: this.value.preShopId,
      preBookId: this.value.preBookId,
      petId: this.value.petId,
      type: this.value.type,
      subType: this.value.subType,
      imgForm: this.value.imgForm,

      idx: this.value.ids,

      adminList: [],
      operateAdminId: this.value.imgForm.operateAdminId?this.value.imgForm.operateAdminId:'',

      positionType: JSON.parse(sessionStorage.getItem('positionType')),

      files: null,
      src: this.value.imgForm.img?this.value.imgForm.img:'',

      loading: false
    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      console.log(e)
      if(e.target.files[0]) {
        this.beforeAvatarUpload(e.target.files[0]).then(res => {
          console.log(res)
          this.files = res
          imageConversion.filetoDataURL(this.files).then(url => {
            this.src = url
          })
        })
        // this.files = e.target.files[0];
        // var windowURL = window.URL || window.webkitURL;
        // this.src = windowURL.createObjectURL(this.files);
      }
    },

    //压缩到指定大小
    beforeAvatarUpload(file) {
      // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJpgOrPng) {
      //   //自己封装的错误提示方法
      //   // this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '上传图片只能是 JPG 或 PNG 格式!',
      //     type: 'warning'
      //   });
      // }
      // // if (!isLt2M) {
      // //   this.$message.error('上传图片大小不能超过 2MB!');
      // // }
      // if (!isLt2M || !isJpgOrPng) {
      //   return false;
      // }
      return new Promise((resolve) => {
        // 压缩到100KB,这里的100就是要压缩的大小,可自定义 //质量为0.6进行压缩
        imageConversion.compressAccurately(file, 200).then(res => {
          resolve(res);
        });
      })
    },



    cancel() {
      this.$emit("close");
    },
    summit() {

      if(!this.files && !this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '图片不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.operateAdminId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择添加人',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.imgForm.id);
      param.append('preBookId', this.preBookId);
      param.append('petId', this.petId);
      param.append('type', this.type);
      param.append('subType', this.subType);
      param.append('operateAdminId', this.operateAdminId);
      param.append('file', this.files);

      imgPostFormData(addPreBookPetImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading= false
      }).catch(() => {
        this.loading = false
      })
    },

    getAdminList() {
      getFormData(getOperateAdminsList, {id: this.preShopId, loginState: 0}).then(data => {
        if(data.code == 200) {
          this.adminList = data.data
          if(this.positionType == 4) {
            this.operateAdminId = JSON.parse(sessionStorage.getItem('accountId'))
          }else {
            this.operateAdminId = this.adminList[0].adminId
          }
        }
      })
    },

  },
  mounted() {
    this.getAdminList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
